import { Field } from 'formik';
import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../../constants/media';
import { StyledCheckbox } from './checkbox';

export const StyledCheckboxWrapper = styled.div`
	margin-right: 2rem;

	${({ disabled }) =>
		disabled &&
		`
			opacity: 0.5;
			pointer-events: none;
		`};

	${media.mobileOnly`
		margin-bottom: 2rem;
	`};

	input {
		display: none;
	}
`;

export const StyledCheckboxLabel = styled.label`
	position: relative;
	font-size: 1.6rem;
	color: ${({ theme }) => theme.colors.black};
	padding-left: 3.4rem;
	cursor: pointer;
	display: block;

	&:hover {
		${StyledCheckbox}:after {
			opacity: 1;
		}
	}
`;

interface Props {
	id: string;
	name: string;
	label: string | React.ReactNode;
	setFieldValue: (x: string, y: boolean) => void;
	disabled?: boolean;
}

const Checkbox = ({
	field: { name, value, onChange, onBlur },
	setFieldValue,
	id,
	label,
	className,
	disabled,
	...props
}) => {
	if (disabled) value = false;
	const filterKeyDowns = e => {
		if (e.keyCode === 32) {
			e.preventDefault();
			setFieldValue(id, !value);
		}
	};
	return (
		<StyledCheckboxWrapper disabled={disabled}>
			<input
				name={name}
				id={id}
				type="checkbox"
				value={id}
				checked={value}
				onChange={onChange}
				onBlur={onBlur}
				disabled={disabled}
				{...props}
			/>
			<StyledCheckboxLabel htmlFor={id}>
				<StyledCheckbox checked={value} tabIndex="0" id={id} onKeyDown={filterKeyDowns} />
				<span>{label}</span>
			</StyledCheckboxLabel>
		</StyledCheckboxWrapper>
	);
};

const FormikCheckbox: FC<Props> = props => <Field component={Checkbox} {...props} />;

export default FormikCheckbox;
